export const getSheetAnnouncementMessage = (status, value) => {
    switch (status) {
        case 'SUCCESS':
            return `SUCCESS: Announcement Value "${value}" pasted from row`;
        case 'FAILED':
            return 'FAILED: Autofill values not found...';
        case 'PARTIAL':
            return 'PARTIAL: Partially found on dispatch list...';
        case 'INFO':
            return 'INFO: Lorem ipsum dispatch list is empty....';
        default:
            return `SUCCESS: Announcement Value "${value}" pasted from row`;
    }
};
